import { memo, useEffect, useState } from "react";

interface ProductDetailsProps {
  image: string;
  title: string;
  currentPrice: string;
  originalPrice?: string;
  onYesClick: () => void;
  onNoClick: () => void;
  onCheckoutClick: () => void;
  productUrl?: string;
  isAddedToCart?: boolean;
}

export const ProductDetails = memo(function ProductDetails({
  image,
  title,
  currentPrice,
  originalPrice,
  onYesClick,
  onNoClick,
  onCheckoutClick,
  productUrl,
  isAddedToCart = false,
}: ProductDetailsProps) {
  const [isConfirming, setIsConfirming] = useState(false);

  useEffect(() => {
    setIsConfirming(false);
  }, [title]);

  return (
    <div className="results-cart nut-rounded-[20px] nut-border nut-border-gray-200 nut-bg-white nut-p-[12px] nut-shadow-sm">
      <div className="nut-flex nut-justify-center nut-w-full nut-h-[190px] nut-max-h-[190px] nut-rounded-[14px] nut-overflow-hidden nut-bg-gray-50">
        <img
          src={image}
          alt={title}
          className="nut-max-w-full nut-h-auto nut-max-h-full nut-object-contain nut-rounded-[14px] nut-object-center nut-p-[8px]"
        />
      </div>
      <div className="results-cart-text nut-mt-[12px]">
        <p className="nut-mb-[5px] nut-text-[15px] [@media(max-width:768px)]:nut-text-[14px]">
          {title}
        </p>
        <div className="nut-flex nut-items-center nut-gap-[6px]">
          <p className="nut-text-[#797AFF] nut-text-[16px] [@media(max-width:768px)]:nut-text-[14px]">
            {currentPrice}
          </p>
          {originalPrice && (
            <p className="nut-text-[#9E9E9E] nut-text-[16px] [@media(max-width:768px)]:nut-text-[14px]">
              <del>{originalPrice}</del>
            </p>
          )}
        </div>
      </div>
      {isConfirming && !isAddedToCart && (
        <div
          className="nut-mt-[14px] nut-rounded-[12px] nut-bg-[#F5F3FF] nut-p-[12px]"
          role="status"
        >
          <p className="nut-text-[13px] nut-font-medium nut-text-[#312E81]">
            Add this item to your Shopify cart?
          </p>
        </div>
      )}
      <div className="results-cart-buttons nut-w-full nut-flex nut-flex-col nut-mt-[14px] nut-gap-[8px]">
        {isConfirming && !isAddedToCart ? (
          <div className="nut-flex nut-gap-[8px]">
            <button
              className="nut-cursor-pointer nut-flex-1 nut-h-[46px] nut-rounded-[999px] nut-bg-white nut-border nut-border-gray-300"
              onClick={() => setIsConfirming(false)}
            >
              Cancel
            </button>
            <button
              className="results-cart-primary-button nut-cursor-pointer nut-flex-1 nut-h-[46px] nut-rounded-[999px] nut-text-white"
              onClick={onYesClick}
            >
              Confirm add
            </button>
          </div>
        ) : (
          <button
            className={`results-cart-primary-button nut-cursor-pointer nut-w-full nut-h-[48px] nut-rounded-[999px] nut-flex nut-items-center nut-justify-center nut-text-white ${isAddedToCart ? "checked-button" : ""}`}
            onClick={
              isAddedToCart ? onCheckoutClick : () => setIsConfirming(true)
            }
          >
            {isAddedToCart ? "View cart & checkout" : "Add to cart"}
          </button>
        )}
        <div className="nut-flex nut-items-center nut-justify-between nut-px-[4px]">
          <button
            className="nut-cursor-pointer nut-text-[13px] nut-text-gray-600"
            onClick={onNoClick}
          >
            Back to results
          </button>
          {productUrl && (
            <a
              className="nut-text-[13px] nut-font-medium nut-text-[#6D5CE7]"
              href={productUrl}
            >
              Product page
            </a>
          )}
        </div>
      </div>
    </div>
  );
});
